//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useState, useEffect, useContext } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';

// === COMPONENTS ===
import { ExpressionContext } from '../../../Context/ExpressionContext';

// === UTILS ===
import { getHexAlpha } from 'components/styles.utils';

//#endregion

//-----------------------------------------------------------------
export function OperatorControls( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const _operator_items = [
    { label: 'AND'    , value: 'AND' },
    { label: 'OR'     , value: 'OR'  },
    { label: '='      , value: '='   },
    { label: '!='     , value: '!='  },
    { label: '+'      , value: '+'   },
    { label: '-'      , value: '-'   },
    { label: '>'      , value: '>'   },
    { label: '<'      , value: '<'   },
    { label: '>='     , value: '>='  },
    { label: '<='     , value: '<='  },
  ]

  const _symbol_colors = {
    undefined: '',
    'AND' : '#00FFFF',
    'OR'  : '#00FF00',
    '='   : '#00FF00',
    '!='  : '#FF0000',
    '+'   : '#B882ED',
    '-'   : '#B882ED',
    '>'   : '#BC8F8F',
    '<'   : '#BC8F8F',
    '>='  : '#BC8F8F',
    '<='  : '#BC8F8F',
  }

  const { updateExpression } = useContext( ExpressionContext );

  const [ symbol, setSymbol ] = useState( props.data?.symbol );

  const color = _symbol_colors[symbol];

  //#endregion

  //#region [STYLES]

  const theme = useTheme();
  const _styles = {
    select_operator: {
      height: '3rem',
      width: '9rem',
      backgroundColor: color + getHexAlpha(30),
    },
  }
  
  const SELECT_OPERATOR = {
    sx: _styles.select_operator,
    labelId: 'operator-label',
    id     : 'operator-select',
    label  : 'Symbol',
    value  : symbol,
    onChange : onChange,
    children: _operator_items.map( item => <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>)
  };
    
  //#endregion

  //#region [EFFECT]

  //#endregion

  //#region [MODIFY]

  //#endregion

  //#region [EVENTS]
  
  //-----------------------------------------------------------------
  function onChange( event ) {
    //-----------------------------------------------------------------
    setSymbol( event.target.value )
    updateExpression( props.id , { symbol: event.target.value } )
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <>
        <FormControl>
          <InputLabel id="operator-label">Symbol</InputLabel>
          <Select { ...SELECT_OPERATOR } />
        </FormControl>
      </>
    );
  }

  //#endregion

  return display();
}
